<template>
  <div>
<!--    <el-row>-->
<!--      <el-col :span="10">-->
<!--        &lt;!&ndash;添加  muted 属性，就可以通过地址栏进入网页的时候自动播放了, 这个属性本身的意思是静音&ndash;&gt;-->
<!--        &lt;!&ndash;<video muted loop="loop" autoplay="autoplay" style="height: 100vh;">&ndash;&gt;-->
<!--        &lt;!&ndash;<source  src="../assets/video/20191205_191351.mp4" type="video/mp4" >;&ndash;&gt;-->
<!--        &lt;!&ndash;</video>&ndash;&gt;-->
<!--        <img src="../assets/video/video.gif" style="height: 100vh">-->
<!--      </el-col>-->
<!--      <el-col :span="14">-->
<!--        <el-row style="z-index: 100">-->
<!--          <el-col :span="20" offset="2" style="margin-top: calc(50vh - 15rem)">-->
    <div style="z-index:-1;position: absolute;width: 100%;height: 100%">
      <img src="../assets/img/backgroundImg.jpg" style="width: 100%;height: 100%">
    </div>


<!--    <div style="z-index:0;position: absolute;width: 100%;height: 100%">-->
<!--      <img src="../assets/img/background2.png" style="z-index:0;position: absolute;width: 100%;height: 120%;top: 0;left: 0;bottom:0;right:0;margin:auto">-->
<!--    </div>-->


    <div style="z-index:1;position: absolute;width: 500px;height: 400px;top: 0;left: 0;bottom:0;right:0;margin:auto;background:rgba(0,0,0,0.1)">
      <div  style="text-align: center; font-size: 24px; display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: center; align-items: center;margin-top: 20px">
        <div>
          <img src="../assets/img/logo.png" style="width: 60px;">&nbsp;&nbsp;
        </div>
        <div>
          <span style="text-align: center;color: white;font-size: 20px">基于物联网的人防警报管理平台</span>
        </div>
      </div>
      <!--            <el-row>-->
      <!--              <el-col :span="16" offset="4">-->
      <div>
<!--        <p style="width: 100%; text-align: center;margin-top: 10px; margin-bottom: 30px; color: #3ba1ff; ">-->
<!--          <span style="padding-bottom:5px; border-bottom:2px solid #3ba1ff">用户名密码登录</span>-->
<!--        </p>-->
        <el-form :ref="Login.params" :model="Login.params" :label-position="left" style="text-align: left;margin-top: 20px" :rules="rules" class="loginForm">
          <el-form-item  prop="username" >
            <el-input type="text" v-model="Login.params.username" @keyup.enter="checkLogin"  prefix-icon="el-icon-user" placeholder="用户名" size="small" style="width: 300px;margin-left: 70px"></el-input>
          </el-form-item>
          <el-form-item  prop="password" >
            <el-input type="password" v-model="Login.params.password" show-password  prefix-icon="el-icon-lock" placeholder="密码" size="small" style="width: 300px;margin-left: 70px"></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 70px">
            <span style="color: white">记住密码?</span>
            <el-switch v-model="accountRemember"></el-switch>
            <span style="color: red;" v-show="accountRemember">登录信息保存期为60天</span>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="width: 70%;height: 4rem;margin-left: 75px" @click="checkLogin" v-loading="isLogining" @keyup.enter="checkLogin">登录系统</el-button>
      </div>
    </div>

<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-col>-->
<!--    </el-row>-->


  </div>
</template>

<script>
  import { ActionContext as store } from 'vuex'

  export default {
    name: 'Login',
    data(){
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户名'));
        } else{
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6 || value.length > 20){
          callback(new Error('密码必须由6 - 20 个字符组成'))
        } else {
          callback();
        }
      };
      return {
        accountRemember:false,
        isLogining: false,
        // 登录请求
        Login:{
          "version": 1,
          "method": "user.Login",
          "params": {
            "username": "",
            "password": "",
          },
          "id": 0
        },
        rules: {
          username: [
            { validator: validatePass, trigger: 'change' }
          ],
          password: [
            { validator: validatePass2, trigger: 'change' }
          ],
        },
      }
    },
    methods:{
      setCookie(cname,cvalue,exdays){
        var d = new Date();
        d.setTime(d.getTime()+(exdays*24*60*60*1000));
        var expires = "expires="+d.toGMTString()
        document.cookie = cname+"="+cvalue+"; "+expires;
      },
      getCookie(cname){ // 获取cookie,没有则为空
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
          var c = ca[i].trim();
          if (c.indexOf(name)===0) { return c.substring(name.length,c.length); }
        }
        return "";
      },
      checkLogin(){
        this.$refs[this.Login.params].validate((valid) => {
          if (valid) {
            this.login();
          } else {
            this.$message({
              type: 'error',
              message: '登录参数不合理，拒绝登陆'
            })
            return false;
          }
        });
      },
      delAllCookie(){
        var myDate=new Date();
        myDate.setTime(-1000);//设置时间
        var data=document.cookie;
        var dataArray=data.split("; ");
        for(var i=0;i<dataArray.length;i++){
          var varName=dataArray[i].split("=");
          document.cookie=varName[0]+"=''; expires="+myDate.toGMTString();
        }
      },

      login(){
        if(this.accountRemember) {
          this.setCookie('username', this.Login.params.username, 60);
          this.setCookie('password', this.Login.params.password, 60);
        }
        else{
          this.delAllCookie();
        }
        this.isLogining = true;
        console.log('登录');
        console.log(this.Login);
        this.$axios.post(this.$mainUrl, this.Login).then(res =>{
          this.isLogining = false;
          console.log('登录请求获得响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$store.commit('setToken', res.data.result.token);
            this.$store.commit('setUserInfo', res.data.result);
            localStorage.setItem('token', res.data.result.token);
            sessionStorage.setItem('setToken',res.data.result.token);
            localStorage.setItem('userId', res.data.result.userId);
            localStorage.setItem('name',res.data.result.name);
            this.$router.push('/bigScreen2');
          }else{
            this.$message({
              type:'error',
              message: '登录失败，' + res.data.error.message
            })
            this.isLogining = false;
          }
        })

      },
    },
    mounted(){
      this.Login.params.username = this.getCookie('username');
      this.Login.params.password = this.getCookie('password');

      if(this.Login.params.username !== "" || this.Login.params.password !== ""){
        this.accountRemember = true;
      }

      // 绑定监听事件，回车登录
      document.onkeydown=e=>{
        let _key=window.event.keyCode;
        if(_key===13){
          this.checkLogin();
        }
      }

    }
  }
</script>

<style scoped>
  .loginForm >>>.el-form-item__error{
    margin-left: 70px;
  }
  /*video{*/
  /*position: fixed;*/
  /*right: 0px;*/
  /*bottom: 0px;*/
  /*min-width: 100%;*/
  /*min-height: 100%;*/
  /*height: auto;*/
  /*width: auto;*/
  /*}*/
  /*#loginCard{*/
  /*  padding: 30px;*/
  /*  background-color: rgba(255,255,255,0.9);*/
  /*  border-radius: 10px;*/
  /*}*/
</style>

